import { api } from "./users";

export const listDriverCash = async ({ dateFrom, dateTo }) => {
  const response = await api.get("/driver-cash/", {
    params: { date_from: dateFrom, date_to: dateTo },
  });
  return response.data;
};

export const getDriverCashTrip = async (tripId) => {
  const response = await api.get(`/driver-cash/${tripId}/`);
  return response.data;
};

export const saveDriverCashSettlement = async (
  tripId,
  { remittedUah, status = "closed", note = "" }
) => {
  const response = await api.post(`/driver-cash/${tripId}/settlement/`, {
    remitted_uah: remittedUah,
    status,
    note,
  });
  return response.data;
};
